import React, { useState, useEffect } from "react";
import { Crown, Check, X, CircleNotch } from "phosphor-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "../lib/api";

export default function GeniBetaProModal({ isOpen, onClose, onSuccess }) {
  const [isActivating, setIsActivating] = useState(false);

  // Registrar a exibição do modal (BETA_PRO_OFFER_SHOWN) uma única vez
  useEffect(() => {
    if (isOpen) {
      api.post('/user/beta-pro/event', { event_name: 'BETA_PRO_OFFER_SHOWN' }).catch(() => undefined);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleActivate = async () => {
    setIsActivating(true);
    try {
      const response = await api.post('/user/beta-pro/activate');
      if (response.data.success) {
        toast.success("GENI PRO Ativado! Aproveite seus 30 dias de Pro gratuitamente.");
        if (onSuccess) {
          await onSuccess();
        }
        onClose();
      } else {
        toast.error(response.data.detail || "Não foi possível ativar o Pro.");
      }
    } catch (error) {
      console.error("Erro ao ativar o Beta PRO:", error);
      toast.error(error.response?.data?.detail || "Erro de conexão ao ativar o Pro.");
    } finally {
      setIsActivating(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75 backdrop-blur-md">
      <div className="relative w-full max-w-[460px] overflow-hidden rounded-[24px] border border-white/10 bg-zinc-950 p-6 shadow-2xl text-white md:p-8">
        
        {/* Botão de Fechar no Canto Superior Direito */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-1.5 text-white/40 hover:bg-white/5 hover:text-white transition-colors duration-200"
          aria-label="Fechar"
        >
          <X size={16} />
        </button>

        <div className="space-y-6">
          {/* Header com Coroa Premium */}
          <div className="flex flex-col items-center text-center space-y-3 pt-2">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-r from-purple-500/20 to-indigo-500/20 text-[#A855F7] border border-purple-500/30 animate-pulse">
              <Crown size={28} weight="fill" />
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-black font-heading tracking-tight text-white leading-tight">
                Obrigado por participar do Beta 💜
              </h3>
            </div>
          </div>

          {/* Texto explicativo em português */}
          <div className="space-y-3 text-sm text-white/70 leading-relaxed text-center font-sans">
            <p>
              Estamos construindo o GENI junto com nossos primeiros usuários.
            </p>
            <p>
              Pretendemos continuar melhorando a plataforma e contamos com sua ajuda para sugerir novas funcionalidades e reportar qualquer problema que encontrar.
            </p>
            <p className="font-semibold text-white/90">
              Como agradecimento por participar do Beta, você ganhou <span className="text-[#A855F7] font-extrabold">30 dias de GENI PRO</span> gratuitamente.
            </p>
            <p>
              Durante esse período, você terá acesso a todos os recursos PRO do GENI.
            </p>
          </div>

          {/* Benefícios Rápidos */}
          <div className="rounded-2xl border border-white/5 bg-white/[0.02] p-4 space-y-2.5">
            <div className="flex items-center gap-2.5 text-xs text-white/80">
              <span className="flex h-4.5 w-4.5 items-center justify-center rounded-full bg-[#00E676]/10 text-[#00E676] border border-[#00E676]/20">
                <Check size={11} weight="bold" />
              </span>
              <span>Acesso global a recursos PRO do GENI Trade</span>
            </div>
            <div className="flex items-center gap-2.5 text-xs text-white/80">
              <span className="flex h-4.5 w-4.5 items-center justify-center rounded-full bg-[#00E676]/10 text-[#00E676] border border-[#00E676]/20">
                <Check size={11} weight="bold" />
              </span>
              <span>Acesso completo ao GENI Options sem restrições</span>
            </div>
            <div className="flex items-center gap-2.5 text-xs text-white/80">
              <span className="flex h-4.5 w-4.5 items-center justify-center rounded-full bg-[#00E676]/10 text-[#00E676] border border-[#00E676]/20">
                <Check size={11} weight="bold" />
              </span>
              <span>Suporte prioritário e feedback direto com os criadores</span>
            </div>
          </div>

          {/* Ação e Botão */}
          <div className="space-y-3 pt-2 text-center">
            <Button
              onClick={handleActivate}
              disabled={isActivating}
              className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-bold py-3.5 px-4 rounded-xl shadow-lg shadow-purple-500/10 transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 flex items-center justify-center gap-2"
            >
              {isActivating ? (
                <>
                  <CircleNotch size={18} className="animate-spin mr-1 animate-spin" />
                  Ativando...
                </>
              ) : (
                "ATIVAR 2 MESES DE PRO"
              )}
            </Button>
            <p className="text-[11px] font-medium text-white/35 uppercase tracking-wider leading-none">
              Sem cobrança automática.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
